// @flow

/**
 * Module dependencies.
 */

import { get } from 'lodash';
import { resolve } from 'url';
import config from 'config';

/**
 * Export `resolveApiUrl`.
 */

export function resolveApiUrl(endpoint: string): string {
  const { api } = config;

  return resolve(get(api, 'baseUrl'), get(api, `endpoints.${endpoint}`));
}



// WEBPACK FOOTER //
// ../src/core/utils/url-resolver.js